class MergeObject {
    private isNestedObj(value): boolean {
        return value && typeof value === "object" && !Array.isArray(value)
    }

    private merge(target, source): void {
        for (const key in source) {
            const value = source[key]

            if (this.isNestedObj(value)) {
                if (!target[key] || typeof target[key] !== "object") {
                    target[key] = {}
                }

                this.merge(target[key], value)
                continue
            }

            target[key] = value
        }
    }

    deepMerge<T, K>(baseObj: T, customObj: K): T {
        const mergedResult = baseObj

        this.merge(mergedResult, customObj)

        return mergedResult
    }
}

const mergeObjects = new MergeObject()

export default mergeObjects
